angular.module("tromanWeb").controller('WageCalculationEditController', ['$q', 'DialogControllerBase', '$scope', 'tromanServer', 'ObjectCache', 'wageCalculation', function ($q, DialogControllerBase, $scope, tromanServer, ObjectCache, wageCalculation) {

    DialogControllerBase.call(this, tromanServer.WageCalculations, $scope);

    this.getTitle = () => { return 'beräkningsregeln "' + this.wageCalculation.Name + '"'; };
    this.getItem = () => { return this.wageCalculation; };

    this.loadItem(wageCalculation)
        .then(wc => {
            return $q.all({
                wageCalculation: $q.when(wc),
                wageTypes: ObjectCache.getWageTypes(wc.WageTypes.nonEmpty().map(x => x.WageType))
            });
        })
        .then(data => {
            this.wageCalculation = data.wageCalculation;
            this.meetingWageTypes = data.wageTypes.filter(x => x.WageModelGroup === 0);
            this.travelWageTypes = data.wageTypes.filter(x => x.WageModelGroup === 2);
        })
        .catch(x => this.showError(x));
}]);
